import {useEffect, useState} from "react";
import axios from "axios";
import {getConfig} from "../../../../services/utils/ConfigUtils";
import {
	GET_ALL_PROTOCOLLI_URL,
} from "../../../../services/utils/ApiUrls";

export default function useGetAllProtocolli(stato, pageNumber, idSoggetto = null, sort, dir) {
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);
	const [protocolli, setProtocolli] = useState([]);
	const [hasMore, setHasMore] = useState(false);
	
	function getData(stato, idSoggetto) {
		if (idSoggetto) {
			return {
				quarantena: {
					soggetto: {
						idSoggetto: idSoggetto
					}
				},
				anagrafica: {
					idSoggetto: idSoggetto
				}
			}
		}
		if (stato === "In gestione") {
			return {
				active: true,
			}
		}
		switch (stato) {
			default:
				return {
					stato: stato,
					active: false,
				};
		}
	}
	
	function getUrl(pageNumber, sort, dir) {
		return GET_ALL_PROTOCOLLI_URL + pageNumber + "/" + sort + "/" + dir;
	}
	
	useEffect(() => {
		setProtocolli([]);
	}, [stato, sort, dir])
	
	useEffect(() => {
		setLoading(true);
		setError(false);
		axios({
			method: "POST",
			url: getUrl(pageNumber, sort, dir),
			data: getData(stato, idSoggetto),
			...getConfig(),
		}).then(response => {
				setProtocolli(prevState => {
					let newState = [...prevState, ...response.data];
					return newState.filter((object, index) => index === newState.findIndex(obj => JSON.stringify(obj) === JSON.stringify(object)))
				})
				setHasMore(response.data.length > 0);
				setLoading(false);
			})
			.catch(() => {
				setError(true);
				setLoading(false);
			})
	}, [stato, pageNumber, idSoggetto, sort, dir])
	
	return {loading, error, protocolli, hasMore};
}
